(function () {
    'use strict';

    function workflowsForEntityController($scope) {
        var vm = this;
        vm.results = [];
        vm.entityId = '';

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            vm.entityId = toParams.entityId;
        });
    }

    workflowsForEntityController.$inject = ['$scope'];

    angular.module('ecap.common').controller('workflowsForEntityController', workflowsForEntityController);
})();